var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Hyperlink component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconHyperlink extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.2628 6.73774C17.5557 7.03063 17.5557 7.5055 17.2628 7.7984L7.79791 17.2633C7.50501 17.5562 7.03014 17.5562 6.73725 17.2633C6.44435 16.9704 6.44435 16.4955 6.73725 16.2026L16.2021 6.73774C16.495 6.44484 16.9699 6.44484 17.2628 6.73774Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.22383 11.5762C6.8534 11.3366 7.52647 11.2328 8.19895 11.2716C8.61248 11.2954 8.92839 11.65 8.90457 12.0635C8.88074 12.477 8.5262 12.7929 8.11267 12.7691C7.65117 12.7425 7.18926 12.8137 6.75721 12.9781C6.32525 13.1425 5.93288 13.3962 5.60581 13.7227C5.60573 13.7228 5.60588 13.7226 5.60581 13.7227L3.5778 15.7507C2.95773 16.3708 2.60938 17.2118 2.60938 18.0887C2.60938 18.5229 2.6949 18.9529 2.86106 19.354C3.02722 19.7552 3.27077 20.1197 3.5778 20.4267C3.88483 20.7337 4.24932 20.9773 4.65048 21.1434C5.05163 21.3096 5.48158 21.3951 5.91578 21.3951C6.7927 21.3951 7.6337 21.0468 8.25377 20.4267L10.2816 18.3989C10.6082 18.0718 10.862 17.6793 11.0264 17.2473C11.1907 16.8152 11.262 16.3533 11.2354 15.8918C11.2116 15.4783 11.5275 15.1237 11.941 15.0999C12.3545 15.0761 12.7091 15.392 12.7329 15.8055C12.7716 16.478 12.6679 17.1511 12.4283 17.7807C12.1888 18.4102 11.819 18.9821 11.343 19.4587L9.31443 21.4873C8.41305 22.3887 7.19052 22.8951 5.91578 22.8951C5.2846 22.8951 4.65959 22.7708 4.07645 22.5292C3.49331 22.2877 2.96346 21.9337 2.51714 21.4873C2.07082 21.041 1.71679 20.5112 1.47524 19.928C1.2337 19.3449 1.10938 18.7199 1.10938 18.0887C1.10938 16.814 1.61576 15.5914 2.51714 14.6901L4.54533 12.6619C5.022 12.1859 5.59426 11.8157 6.22383 11.5762Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.6867 2.51275C15.5881 1.61137 16.8106 1.10498 18.0853 1.10498C19.3601 1.10498 20.5826 1.61137 21.484 2.51275C22.3854 3.41412 22.8918 4.63665 22.8918 5.91139C22.8918 7.18613 22.3854 8.40866 21.484 9.31003L19.4558 11.3382L19.4553 11.3387C18.9787 11.8145 18.4068 12.1843 17.7773 12.4239C17.1477 12.6634 16.4747 12.7672 15.8023 12.7285C15.3887 12.7047 15.0728 12.3502 15.0966 11.9367C15.1203 11.5231 15.4749 11.2072 15.8884 11.231C16.3499 11.2575 16.8118 11.1863 17.2439 11.0219C17.6759 10.8576 18.0682 10.6038 18.3953 10.2774C18.3954 10.2773 18.3955 10.2772 18.3956 10.2771L20.4233 8.24937C21.0434 7.6293 21.3918 6.7883 21.3918 5.91139C21.3918 5.03448 21.0434 4.19348 20.4233 3.57341C19.8033 2.95333 18.9623 2.60498 18.0853 2.60498C17.2084 2.60498 16.3674 2.95333 15.7474 3.57341L13.7205 5.60024C13.7203 5.60045 13.7201 5.60067 13.7199 5.60088C13.3943 5.92832 13.1414 6.32075 12.9778 6.75255C12.814 7.18464 12.7433 7.64642 12.7702 8.1077C12.7944 8.52121 12.4787 8.876 12.0652 8.90014C11.6517 8.92428 11.2969 8.60863 11.2728 8.19513C11.2335 7.52313 11.3366 6.85042 11.5751 6.22097C11.8137 5.59152 12.1824 5.0195 12.6572 4.5423L12.6585 4.54094L12.6585 4.54094L14.6867 2.51275Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconHyperlink.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconHyperlink.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconHyperlink.prototype, "size", void 0);
if (customElements.get('cat-icon-hyperlink') === undefined) {
    customElements.define('cat-icon-hyperlink', BlocksIconHyperlink);
}
